import React, { forwardRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import { Theme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import { useLocation } from "react-router";
import { NavLink, NavLinkProps } from "react-router-dom";
import { useObservable } from "src/framework/store/storeUtil";
import { ListItemButton } from "@mui/material";
import { IMenuItem, openMenu$ } from "src/framework/store/AppStore";
import theme from "src/theme/light";

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      color: "#3E5055",
      paddingLeft: theme.spacing(3),
    },

    expandable: {
      color: "rgba(0, 163, 53, 0.8)",
    },

    active: {
      color: "#fff",
      borderLeft: '6px solid #00AF39',
      background: "linear-gradient(90deg, #017226 0%, #1A1C1B 100%)",
    },
    subItem: {
      color: "#017226",
      background: "rgba(0, 114, 37, 0.2) !important",
    },

    icon: { color: "#fff" },
    iconDefault: { color: "#3E5055" },
    iconSubItem: { color: "#017226" },
  })
);

const MenuItem = ({
  menuItem,
  index = -1,
  current = -1,
  nested = false,
  setCurrent = () => null
}: {
  menuItem: IMenuItem;
  nested: boolean;
  index?: number;
  current?: number;
  setCurrent?: Function;
}) => {
  const classes = useStyles();

  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const openMenu = useObservable(openMenu$);

  const selected = location.pathname === menuItem.link;
  const subItemSelected: boolean = menuItem?.menuItem?.find(i => i?.link === location.pathname) ? true : false;
  const isActive = index === current;

  const isExpandable =
    menuItem.link === null &&
    !!menuItem.menuItem &&
    menuItem?.menuItem?.length > 0;

  useEffect(() => {
    if (isActive) {
      
    }
  }, [isActive, setCurrent, index, location.pathname]);
  
  useEffect(() => {
    if (!subItemSelected && open && current !== index) {
      setOpen(false);
    }
  }, [open, subItemSelected, current, index]);

  const handleClick = () => {
    if ((isExpandable && !nested) || !isExpandable  || nested) {
      setCurrent(index);
    }

    if (isExpandable) {
      setOpen(!open);
    }
  };

  const itemClass = isActive 
    ? (menuItem.isSubItem ? `${classes.subItem}` : `${classes.active}`) 
    : "";

  const controllClasses = nested 
    ? `${classes.nested} ` + itemClass 
    : itemClass

  const iconClasses = (open && subItemSelected) || selected 
    ? (menuItem.isSubItem ? `${classes.iconSubItem}` : `${classes.icon}`)
    : `${classes.iconDefault}`

  interface LinkBehaviorProps extends NavLinkProps {
    end?: boolean;
  }

  const LinkBehavior = forwardRef<HTMLAnchorElement, LinkBehaviorProps>(
    function LinkBehavior(props, ref) {
      return <NavLink ref={ref} {...props} />;
    }
  );

  return (
    <div>
      <ListItem disablePadding className={controllClasses}>
        <ListItemButton
          component={LinkBehavior}
          to={menuItem.link || location.pathname}
          selected={selected}
          onClick={handleClick}
        >
          {menuItem.icon && (
            <Tooltip title={menuItem.text}>
              <ListItemIcon>
                <Icon className={iconClasses}>{menuItem.icon}</Icon>
              </ListItemIcon>
            </Tooltip>
          )}

          {openMenu && (
            <>
              <ListItemText primary={menuItem.text} />
              {isExpandable ? open ? <ExpandLess /> : <ExpandMore /> : null}
            </>
          )}
        </ListItemButton>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {menuItem?.menuItem?.map((subMenu, index) => (
          <MenuItem
            menuItem={subMenu}
            nested={true}
            key={`subMenu-${btoa("subMenu-" + index)}`}
          />
        ))}
      </Collapse>
    </div>
  );
};

export { MenuItem };
